import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./SuccessPage.css";

const SuccessPage = () => {
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    const data = localStorage.getItem("paymentDetails");
    if (data) {
      try {
        setPaymentData(JSON.parse(data));
      } catch (err) {
        console.error("Failed to parse payment data", err);
      }
    }
  }, []);

  const handleGoHome = () => {
    localStorage.removeItem("paymentDetails");
    navigate("/");
  };

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            fill="green"
            className="bi bi-check-circle-fill"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.97 10.03a.75.75 0 0 0 1.07 0l3.992-3.992a.75.75 0 1 0-1.06-1.06L7.5 8.439 5.53 6.47a.75.75 0 1 0-1.06 1.06l2.5 2.5z" />
          </svg>
        </div>
        <h2 className="success-title">Payment Successful!</h2>
        <p className="success-message">
          Thank you for your payment. Your transaction was completed
          successfully.
        </p>

        {paymentData && (
          <div className="order-details-grid">
            <div className="detail-pair">
              <span>
                <strong>Order ID:</strong> {paymentData.data.order_id}
              </span>
              <span>
                <strong>Amount Paid:</strong> ₹{paymentData.data.amount}
              </span>
            </div>
            <div className="detail-pair">
              <span>
                <strong>Name:</strong> {paymentData.data.name}
              </span>
              <span>
                <strong>Email:</strong> {paymentData.data.email}
              </span>
            </div>
            <div className="detail-pair">
              <span>
                <strong>Mobile:</strong> {paymentData.data.mobile_number}
              </span>
              <span>
                <strong>Profession:</strong> {paymentData.data.profession}
              </span>
            </div>
            <div className="detail-single">
              <strong>Location:</strong> {paymentData.data.city},{" "}
              {paymentData.data.state}
            </div>
          </div>
        )}

        <button className="success-button" onClick={handleGoHome}>
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;
